<template>
    <CRow>
        <CCol col>
            <div class="col-lg-12 control-section" style="padding:10px;position:relative;">
                <div style="width:100%;">
                    <ejs-grid ref='grid' id="statusAlertGridId" :dataSource="data" :allowFiltering='true' :commandClick='commandClick' :allowPaging="true"
                              :allowTextWrap='true' :textWrapSettings='wrapSettings' :allowResizing='true' :query='gridQuery'
                              :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete'
                              :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' 
                              :pageSettings='pageSettings' :actionComplete='actionComplete' :actionBegin="actionBegin"
                              :actionFailure="actionFailure" :filterSettings='filterOptions' :queryCellInfo='customiseCell' width="100%" height="100%">
                        <e-columns>
                            <e-column field='triggerAlertId' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                            <e-column field='triggerDate' headerText='Alert Date' textAlign='Right' :format='dateFormatOptions' type='date' width=150></e-column>
                            <e-column field='alertType' headerText='Alert' width=120></e-column>
                            <e-column field='clientName' headerText='Client' :allowEditing="false" width=210></e-column>
                            <e-column field='stateName' headerText='Country' :allowEditing="false" width=150></e-column>
                            <e-column field='companyName' headerText='Company' :allowEditing="false" width=210></e-column>
                            <e-column field='contractName' headerText='Contract' :allowEditing="false" width=300></e-column>
                            <e-column field='productName' headerText='Product' :allowEditing="false" width=150></e-column>
                            <e-column field='pricingAreaName' headerText='Price Area' textAlign='Left' width=150 type="string"></e-column>
                            <e-column field='tradeablePeriodName' headerText='Period' width=120></e-column>
                            <!--<e-column field='triggerTypeId' headerText='Trigger Type' textAlign='Right' :validationRules="requiredRules" editType='dropdownedit' :edit='triggerTypeParams' foreignKeyField="id" foreignKeyValue='name' :dataSource='triggerTypes' width=150></e-column>-->
                            <e-column field='triggerTypeName' headerText='Trigger Type' :visible='true' width=150 textAlign='Right'></e-column>
                            <e-column field='triggerPrice' headerText='Price' textAlign='Right' :validationRules="percentageRules" type="number" format="n3" editType='numericedit' :edit='numericParams' width=150></e-column>
                            <e-column headerText='Watched Window' :columns='dateColumns' textAlign="Center"></e-column>
                            <e-column field='alertStatus' headerText='Status' width=120></e-column>
                            <e-column headerText='Actions' width=230 textAlign='left' :commands='commands'></e-column>
                            <e-column field='utilityTypeName' headerText='Commodity' :allowEditing="false" :visible='false' width=90></e-column>
                            <e-column field='tradeablePeriodId' headerText='Watched Period' textAlign='Right' :visible='false' :validationRules="requiredRules" editType='dropdownedit' :edit='tradebalePeriodParams' foreignKeyField="id" foreignKeyValue='name' :dataSource='tradebalePeriods' width=50></e-column>
                            <e-column field='unit' headerText='Unit' :visible='false' width=60></e-column>
                            <e-column field='tolerance' headerText='Tolerance' :visible='false' textAlign='Right' :validationRules="percentageRules" type="number" format="n1" editType='numericedit' :edit='percentageParams' width=70></e-column>
                            <e-column field='referenceTypeId' headerText='Reference Type' textAlign='Right' :visible='false' :validationRules="requiredRules" editType='dropdownedit' :edit='referenceTypeParams' foreignKeyField="id" foreignKeyValue='name' :dataSource='referenceTypes' width=110></e-column>
                            <e-column field='referenceTypeName' headerText='Reference Type' :visible='false' width=120></e-column>
                            <e-column field='applyUntilEnd' headerText='Apply until Default Deadline' displayAsCheckBox='true' :visible='false' :edit='checkboxParams' editType='booleanedit' type='boolean' width=120></e-column>
                            <e-column field='notifyOnSystem' headerText='Notify On System' defaultValue='true' displayAsCheckBox='true' :visible='false' :allowEditing="false" editType='booleanedit' type='boolean' width=120></e-column>
                            <e-column field='notifyEmailAddresses' headerText='Notify Email Addresses' multiline="true" :edit="multilineParams" :visible='false' width=120></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
                    <ejs-dialog :buttons='alertDlgButtons' cssClass="greyBackground" ref="alertDialog" id="statusAlertDialog" v-bind:visible="false" :animationSettings='animationSettings' :showCloseIcon='showCloseIcon' :open="dialogOpen" :close="dialogClose" :width='alertWidth' :header="header" :allowDragging="draggable" :position="position">
                        <h5 class="ml-5" id="graphHeader">  {{alertType}} Trigger</h5><br />
                        <label class="mr-5 float-right">Alert issued on : {{triggerDate}}</label><br />
                        <br />
                        <label class="ml-5">{{alertText}}</label><br />
                        <br />
                        <div class="row">
                            <div class="column ml-3">
                                <label class="ml-5"><b>Client</b>: {{client}}</label><br />
                                <label class="ml-5"><b>Country</b>: {{country}}</label><br />
                                <label class="ml-5"><b>Price Area</b>: {{pricingAreaName}}</label><br />
                                <label class="ml-5"><b>Utility</b>: {{utility}}</label><br />
                                <label class="ml-5"><b>Product</b>: {{product}}</label><br />
                                <label class="ml-5"><b>Company</b>: {{company}}</label><br />
                                <label class="ml-5"><b>Contract Name</b>: {{contractName}}</label><br />
                                <label class="ml-5"><b>Contract ID</b>: {{contractId}}</label><br />
                                <br />

                            </div>
                            <div class="column ml-5">
                                <label class="ml-5"><b>Watch Period</b>: {{watchPeriod}}</label><br />
                                <label class="ml-5"><b>Trigger Type</b>: {{type}}</label><br />
                                <label class="ml-5"><b>Trigger Price</b>: {{triggerPrice}} {{contractUnits}}</label><br />
                                <label class="ml-5"><b>Market Price</b>: {{marketPrice}} {{contractUnits}}</label><br />
                                <label class="ml-5"><b>Delta to Trigger</b>: {{delta}} {{contractUnits}}</label><br />
                                <br />
                            </div>
                        </div>
                        <!--<h1 class="expiredTriggerHeader">  </h1>-->
                        <ejs-chart id="alertChartContainer" :title='title' :zoomSettings='zoom' :primaryXAxis='primaryXAxis' :primaryYAxis='primaryYAxis' :tooltip='tooltip' :textRender='textRender' :titleStyle="titleStyle" width="700px" height="350px">
                            <e-series-collection>
                                <e-series xName='x' yName='y' name='Market Price' type='MultiColoredLine' pointColorMapping='color' :marker='marker'> </e-series>
                            </e-series-collection>
                        </ejs-chart>
                    </ejs-dialog>
                </div>
</CCol>
    </CRow>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn } from "@syncfusion/ej2-vue-grids";
    import { DropDownList } from "@syncfusion/ej2-dropdowns";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../common/syncfusion';
    import { Query } from '@syncfusion/ej2-data';
    import gridOptions from '../../common/gridOptions'
    import dates from '../../common/dates'
    import urls from '../../common/urls';
    import apis from '../../common/network'
    import { DatePickerPlugin, DatePicker } from '@syncfusion/ej2-vue-calendars';
    import { CheckBoxPlugin, CheckBox } from "@syncfusion/ej2-vue-buttons";
    import { ChartPlugin, ColumnSeries, StripLine, LineSeries, DataLabel, Category, DateTime, Tooltip, ChartAnnotation, Zoom, MultiColoredLineSeries } from "@syncfusion/ej2-vue-charts";
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
    import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
    import { enableRipple } from '@syncfusion/ej2-base';
    import { TextBox } from "@syncfusion/ej2-inputs";
    import store from '../../store';
    import moment from 'moment';

    Vue.use(ChartPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    Vue.use(ButtonPlugin);
    Vue.use(DialogPlugin);
    enableRipple(true);

   
    let tradebalePeriodObj, tradebalePeriodElem, triggerTypeObj, triggerTypeElem, referenceTypeObj, referenceTypeElem, datePickerObj, elem, startDatePickerObj, startDateElem, checkboxElem, checkBoxObj;
    let  multilineElem, multilineObj;
    export default {
        props: ['reportContractId', 'clientId', 'reportTradingGroupId'],
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
        },
        data() {
            return {
                // needed because of form being loaded from tab,in such cases this isnt available and store is loaded from import
                store: store,
                // needed for vieweing dialog,initally not there then appears
                showCloseIcon: false,
                statusAlertcontractId: parseInt(this.reportContractId),// when form is loaded from contracts reporting ui, when not it will be undefined
                alertWidth: '750px',
                position: { X: 'center', Y: 'center' },
                animationSettings: { effect: 'Zoom' },
                alertDlgButtons: [{ click: this.alertDlgBtnClick, buttonModel: { content: 'Dismiss', isPrimary: true } }],
                ShowBtn: true,
                draggable: true,
                header: " ",
                zoom:
                {
                    enableMouseWheelZooming: false,
                    enablePinchZooming: false,
                    enableSelectionZooming: true
                },
                gridQuery: new Query().addParams("triggerAlert", "status").addParams("contractId", this.reportContractId).addParams("clientId", this.clientId).addParams("tradingGroupId", this.reportTradingGroupId),
                // this is done due to header column
                dateColumns: [
                    {
                        field: 'triggerStartDate',
                        headerText: 'Start Date',
                        width: 150,
                        textAlign: 'Right',
                        minWidth: 10,
                        format: { type: 'date', format: 'dd/MM/yyyy' },
                        type: 'date',
                        validationRules: { required: true },
                        edit: {
                            create: function () {
                                startDateElem = document.createElement('input');
                                return startDateElem;
                            },
                            read: () => {
                                return startDatePickerObj.value;
                            },
                            destroy: () => {
                                startDatePickerObj.destroy();
                            },
                            // start date cant be before today,as trigger can start at least from today,cant set it up to start from yesterday as the job wont do data retroactivly
                            // max will be later set in the code to the last day of the period prior to the one chosen,as trading can be done until a period starts,and having trigger when you cant trade doesnt make sense
                            write: (args) => {
                                startDatePickerObj = new DatePicker({
                                    value: new Date(args.rowData[args.column.field]),
                                    floatLabelType: 'Always',
                                    format: 'dd/MM/yyyy',
                                    //sets the min.
                                    min: dates.addDays(new Date(), 1),
                                    placeholder: 'Start Date',
                                    firstDayOfWeek: 1,
                                });
                                startDatePickerObj.appendTo(startDateElem);
                            }
                        }
                    },
                    {
                        field: 'triggerEndDate',
                        headerText: 'End Date',
                        width: 150,
                        textAlign: 'Right',
                        minWidth: 10,
                        format: { type: 'date', format: 'dd/MM/yyyy' },
                        type: 'date',
                        validationRules: { required: true, minlength: [(args) => { return this.dateValidation(args) }, 'End Date must be greater than Start Date.'] },
                        edit: {
                            create: function () {
                                elem = document.createElement('input');
                                return elem;
                            },
                            read: () => {
                                return datePickerObj.value;
                            },
                            destroy: () => {
                                datePickerObj.destroy();
                            },
                            // end date cant be before tomorow,as trigger can start at least from today,cant set it up to start from yesterday as the job wont do data retroactivly,and it must last for at least a day
                            // max will be later set in the code to the last day of the period prior to the one chosen,as trading can be done until a period starts,and having trigger when you cant trade doesnt make sense
                            write: (args) => {
                                datePickerObj = new DatePicker({
                                    value: new Date(args.rowData[args.column.field]),
                                    floatLabelType: 'Always',
                                    format: 'dd/MM/yyyy',
                                    //sets the min after the startdate.
                                    min: dates.addDays(new Date(), 1),
                                    placeholder: 'End Date',
                                    firstDayOfWeek: 1,
                                });
                                datePickerObj.appendTo(elem);
                            }
                        }
                    }
                ],
                referenceTypes: SyncHelper.getDataManager('Utils/referenceTypes'),
                triggerTypes: SyncHelper.getDataManager('Utils/triggerTypes'),
                contractUnits: "",
                units: "",
                alertType: "",
                triggerDate: "",
                client: "",
                country: "",
                utility: "",
                company: "",
                contractName: "",
                contractId: "",
                watchPeriod: "",
                triggerPrice: "",
                marketPrice: "",
                delta: "",
                alertText: "",
                type: "",
                product: "",
                pricingAreaName: "",
                wrapSettings: { wrapMode: 'Header' },
                commands: [{ buttonOption: { cssClass: 'e-primary view', content: 'View' } },
                    { buttonOption: { cssClass: 'secondary mark', content: 'Mark as Seen' } }],
                tradebalePeriods: SyncHelper.getDataManager('Utils/contractTradeablePeriods'),
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy' },
                data: SyncHelper.getDataManager("TriggerAlert"),
                tradebalePeriodParams: {
                    create: () => {
                        tradebalePeriodElem = document.createElement('input');
                        return tradebalePeriodElem;
                    },
                    read: () => {
                        return tradebalePeriodObj.value;
                    },
                    destroy: () => {
                        tradebalePeriodObj.destroy();
                    },
                    write: (args) => {
                        tradebalePeriodObj = new DropDownList({
                            query: new Query().addParams("contractId", args.rowData.contractId),
                            dataSource: this.tradebalePeriods,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Tradeable Period',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            change: (args) => {
                                if (args.value != null) {
                                    apis.protectedApi(`${urls.apiBaseUrl}ContractTrigger/PeriodDeadline/${args.value}`).then(it => {

                                        if (checkBoxObj.checked) {

                                            datePickerObj.value = it.data.lastDay;
                                        }
                                        startDatePickerObj.max = it.data.lastDay;
                                        datePickerObj.max = it.data.lastDay;
                                    }).catch(
                                        response => {
                                            var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                                            gridOptions.errorAlert("Error: " + message);
                                        }
                                    );
                                }
                            }
                        });
                        tradebalePeriodObj.appendTo(tradebalePeriodElem);
                    }
                },
                referenceTypeParams: {
                    create: () => {
                        referenceTypeElem = document.createElement('input');
                        return referenceTypeElem;
                    },
                    read: () => {
                        return referenceTypeObj.value;
                    },
                    destroy: () => {
                        referenceTypeObj.destroy();
                    },
                    write: (args) => {
                        referenceTypeObj = new DropDownList({
                            dataSource: this.referenceTypes,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Reference Type',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                        });
                        referenceTypeObj.appendTo(referenceTypeElem);
                    }
                },
                triggerTypeParams: {
                    create: () => {
                        triggerTypeElem = document.createElement('input');
                        return triggerTypeElem;
                    },
                    read: () => {
                        return triggerTypeObj.value;
                    },
                    destroy: () => {
                        triggerTypeObj.destroy();
                    },
                    write: (args) => {
                        triggerTypeObj = new DropDownList({
                            cssClass: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyValue] == 'Lower' ? 'greenBox' : 'redBox' : null),
                            dataSource: this.triggerTypes,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Trigger Type',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            change: (args) => {
                                if (args.itemData.name == 'Lower') {
                                    args.element.parentElement.classList.remove('redBox');
                                    args.element.parentElement.classList.add('greenBox');
                                } else {
                                    args.element.parentElement.classList.remove('greenBox');
                                    args.element.parentElement.classList.add('redBox');
                                }
                            }
                        });
                        triggerTypeObj.appendTo(triggerTypeElem);

                    }
                },
                checkboxParams: {
                    create: function () {
                        checkboxElem = document.createElement('input');
                        return checkboxElem;
                    },
                    read: () => {
                        return checkBoxObj.checked;
                    },
                    destroy: () => {
                        checkBoxObj.destroy();
                    },
                    write: (args) => {
                        checkBoxObj = new CheckBox({
                            cssClass: 'e-primary',
                            checked: args.rowData[args.column.field],
                            disabled: false,
                            //value: args.rowData[args.column.field],
                            label: "Apply until End Date",
                            change: (args) => {
                                if (args.checked && tradebalePeriodObj.value != undefined) {
                                    apis.protectedApi(`${urls.apiBaseUrl}ContractTrigger/PeriodDeadline/${tradebalePeriodObj.value}`).then(it => {
                                        datePickerObj.value = it.data.lastDay;
                                    }
                                    ).catch(
                                        response => {
                                            var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                                            gridOptions.errorAlert("Error: " + message);
                                        }
                                    );
                                }
                                if (args.checked == true) {
                                    datePickerObj.enabled = false;
                                } else {
                                    datePickerObj.enabled = true;
                                }
                            }
                        });
                        checkBoxObj.appendTo(checkboxElem);
                    }
                },
                multilineParams: {
                    create: function () {
                        multilineElem = document.createElement("textarea");
                        return multilineElem;
                    },
                    read: () => {
                        return multilineObj.value;
                    },
                    destroy: () => {
                        multilineObj.destroy();
                    },
                    write: args => {
                        multilineObj = new TextBox({
                            value: args.rowData["notifyEmailAddresses"],
                            floatLabelType: "Always",
                            placeholder: 'Notify Email Addresses',
                            multiline: true,

                        });
                        multilineObj.appendTo(multilineElem);
                    }
                },
                //pageSettings: gridOptions.pageSettings,
                pageSettings: { pageSizes: [10, 20, 50, 100], pageSize: 10, pageCount: 4 },
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: false,
                    allowAdding: false,
                    allowDeleting: store.state.permissions["Permissions.Triggers.Delete"],
                    mode: 'Dialog'
                },
                numericParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 4,
                        format: "n4"
                    }
                },
                percentageParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 1,
                        format: "n1"
                    }
                },
                toolbar: ['Delete', 'ExcelExport'],
                requiredRules: { required: true },
                percentageRules: { required: true, number: true },
                nameRules: { required: true, maxLength: 50 },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings,

                seriesData: this.marketPricesPerDay,
                primaryXAxis: {
                    valueType: 'DateTime', intervalType: 'Days',
                    title: 'Date',
                    titleStyle: {
                        size: '16px', color: '#4d4d4d',
                        fontFamily: 'Arial Narrow', fontWeight: 'bold'
                    }
                },
                primaryYAxis:
                {
                    title: 'Price',
                    titleStyle: {
                        size: '16px', color: '#4d4d4d',
                        fontFamily: 'Arial Narrow', fontWeight: 'bold'
                    },
                    labelFormat: 'n3'
                },
                tooltip: { enable: true },
                titleStyle: {
                    //fontFamily: "Arial",
                    //fontStyle: 'italic',
                    //fontWeight: 'regular',
                    //color: "#E27F2D",
                    //size: '23px'
                },
                title: this.title,
                marker: { dataLabel: { visible: true } },

            };
        },
        methods: {
            alertDlgBtnClick: function () {
                this.$refs.alertDialog.hide();
            },
            dialogClose: function () {
                this.ShowBtn = true;
            },
            dialogOpen: function () {
                this.ShowBtn = false;
            },
            dateValidation: function (args) {
                return startDatePickerObj.value <= datePickerObj.value;
            },
            textRender: function (args) {
                //if (this.type != "Lower" && args.point.y >= this.lowerPrice) {
                //    args.text = args.text + ' Trigger Hit';
                //    args.color = 'yellow';
                //}
                //else if (this.type == "Lower" && args.point.y <= this.higherPrice) {
                //    args.text = args.text + ' Trigger Hit';
                //    args.color = 'yellow';
                //}
                //else { args.text = ""; }
                args.text = "";
            },
            commandClick: function (args) {
                var triggerAlertId = args.rowData.triggerAlertId;
                if (args.target.classList.contains("view")) {
                    this.loadGraph(args.rowData);
                }
                else if (args.target.classList.contains("mark")) {
                    this.changeAlertStatus(triggerAlertId, this.$refs.grid);
                }
            },
            changeAlertStatus: function (args, grid) {
                apis.protectedApi.put(`${urls.apiBaseUrl}TriggerAlert/UpdateStatus/`, { triggerAlertId: args }).then(it => {
                    grid.refresh();
                }).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );
            },
            loadGraph: function (args) {
                apis.protectedApi(`${urls.apiBaseUrl}ContractTrigger/TriggerGraphData/${args.triggerId}`).then(it => {
                    this.higherPrice = it.data.higherPrice;
                    this.lowerPrice = it.data.lowerPrice;
                    this.marketPricesPerDay = it.data.marketPricesPerDay;
                    this.title = it.data.title;
                    this.type = it.data.type;
                    args.triggerEndDate.setDate(args.triggerEndDate.getDate() + 1);
                    this.alertText = args.alertType == "Expired" ? "Your Trigger has expired on the " + moment(String(args.triggerEndDate)).format('DD/MM/YYYY') +". Reset your Watched Window End Date.":
                        "Your Trigger has gone live on the " + moment(String(args.triggerStartDate)).format('DD/MM/YYYY'); 

                    var chart = document.getElementById('alertChartContainer').ej2_instances[0];
                    chart.primaryYAxis =
                    {
                        title: 'Price' + ' ' + it.data.unit
                    };
                    chart.primaryYAxis.stripLines =
                        [//striplines are for the green/red part lines on the grid, we have one that is the span,and the upper and lower one that deffer depending on type
                        {
                            start: this.lowerPrice, end: this.higherPrice, text: this.type, color: this.type == "Lower" ? "#1a9470" : '#f25c54', visible: true, zIndex: 'Behind', opacity: 0.5 },

                        { start: this.type == "Lower" ? this.higherPrice : this.lowerPrice, size: 1, text: this.type == "Lower" ? "" + this.higherPrice : "" + this.lowerPrice, textStyle: { size: 15, color: this.type == "Lower" ? '#1a9470' : '#f25c54' }, verticalAlignment: this.type == "Lower" ? "End" : "Start", horizontalAlignment: "Start", sizeType: 'Pixel', dashArray: "10,5", color: this.type == "Lower" ? "#1a9470" : '#f25c54' },
                        { start: this.type == "Lower" ? this.lowerPrice : this.higherPrice, size: 1, text: this.type == "Lower" ? "" + this.lowerPrice : "" + this.higherPrice, textStyle: { size: 15, color: this.type == "Lower" ? "#1a9470" : '#f25c54' }, verticalAlignment: this.type == "Lower" ? "Start" : "End", horizontalAlignment: "Start", sizeType: 'Pixel', color: this.type == "Lower" ? "#1a9470" : '#f25c54' },

                        ];
                    chart.series[0].dataSource = this.marketPricesPerDay;
                    chart.refresh();
                    if (args.alertType == "Expired") {
                        document.getElementById('graphHeader').classList.add('alertExpiredTriggerHeader');
                        document.getElementById('graphHeader').classList.remove('alertLiveTriggerHeader');
                    }
                    else {
                        document.getElementById('graphHeader').classList.add('alertLiveTriggerHeader');
                        document.getElementById('graphHeader').classList.remove('alertExpiredTriggerHeader');
                    }
                    //aditional data on dialog above graph
                    if (args.alertType == "Watch Zone") {
                        this.alertType = args.alertType + " " + "Entered";
                    } else {
                        this.alertType = args.alertType;
                    }
                    this.contractUnits = args.unit;
                    this.triggerDate = moment(String(args.triggerDate)).format('DD/MM/YYYY');
                    this.client = args.clientName;
                    this.country = args.stateName;
                    this.utility = args.utilityTypeName;
                    this.company = args.companyName;
                    this.contractName = args.contractName;
                    this.pricingAreaName = args.pricingAreaName;
                    this.contractId = args.contractId;
                    this.watchPeriod = args.tradeablePeriodName;
                    this.triggerPrice = args.triggerPrice.toFixed(3);
                    this.marketPrice = args.marketPrice.toFixed(3);
                    this.delta = args.delta.toFixed(3);
                    this.product = args.productName;
                    this.$refs.alertDialog.show();
                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );
            },
            toolbarClick(args) {
                if (args.item.id.includes('excelexport')) {
                    // hide and show dropdown columns and show text columns as they always have value but dropdowns if not on the page will not have values
                    this.$refs.grid.getColumns()[11].visible = false;

                    this.$refs.grid.getColumns()[12].visible = true;
                }
                gridOptions.excelExport(args, "Contract Triggers.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
                // hide and show dropdown columns and show text columns as they always have value but dropdowns if not on the page will not have values,and return to the state before export
                this.$refs.grid.getColumns()[11].visible = true;

                this.$refs.grid.getColumns()[12].visible = false;
            },

            actionBegin(args) {
                gridOptions.actionBegin(args);
                if (args.requestType == 'beginEdit') {

                    if (args.rowData.alertType == 'Expired') {
                        for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                            this.$refs.grid.getColumns()[i].isPrimaryKey = true;

                        }
                    } else {
                        for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                            this.$refs.grid.getColumns()[i].isPrimaryKey = false;

                        }
                    }
                }
                if (args.requestType == 'save') {
                    //args.dialog.dialogOpen = false;
                    showSpinner(document.getElementById('mainSpinner'));
                }
                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));
                }
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].headerText == "Apply until Default Deadline") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerActions") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerStatus") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "applyUntilEnd") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "notifyOnSystem") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "notifyEmailAddresses") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "statusDate") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "tradeablePeriodName") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "tradeablePeriodId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "referenceTypeId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerStartDate") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerEndDate") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        }  else if (this.$refs.grid.getColumns()[i].field == "tolerance") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerDate") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "alertType") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "alertStatus") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "utilityTypeName") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } 
                    }
                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                if (args.requestType == 'beginEdit') {

                    if (args.rowData.alertType == 'Expired') {

                        for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                            this.$refs.grid.getColumns()[i].isPrimaryKey = true;

                        }
                        referenceTypeObj.enabled = false;
                        tradebalePeriodObj.enabled = false;
                        startDatePickerObj.enabled = false;
                        triggerTypeObj.enabled = false;
                        referenceTypeObj.enabled = false;
                        multilineObj.enabled = false;
                        checkBoxObj.disabled = true;
                      
                    } else {
                        for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                            this.$refs.grid.getColumns()[i].isPrimaryKey = false;

                        }

                        referenceTypeObj.enabled = true;
                        tradebalePeriodObj.enabled = true;
                        startDatePickerObj.enabled = true;
                        triggerTypeObj.enabled = true;
                        referenceTypeObj.enabled = true;
                        multilineObj.enabled = true;
                        checkBoxObj.disabled = false;
                        
                    }
                }



                if (args.requestType == "refresh") {
                    
                    if (this.reportContractId != undefined) {
                        apis.protectedApi(`${urls.apiBaseUrl}TriggerAlert/GroupCounts?contractId=${this.reportContractId}`).then(it => {
                            this.deadline = it.data.deadline;
                            this.status = it.data.status;
                            this.hit = it.data.hit;
                            this.AlertsCount = this.hit + this.deadline + this.status;
                            //this is for counter in header, count unseen alerts
                            if (document.getElementsByClassName('dueLiveTriggerHeader').length > 0) {
                                document.getElementsByClassName('dueLiveTriggerHeader')[0].innerHTML = "<u>TRIGGERS STATUS" + " " + this.status + "</u>";
                                document.querySelectorAll('[role="presentation"]')[6].innerHTML = "Alerts" + "(" + this.AlertsCount + ")";
                            }
                        });

                    }
                    if (this.clientId != undefined) {
                        apis.protectedApi(`${urls.apiBaseUrl}TriggerAlert/GroupCounts?clientId=${this.clientId}`).then(it => {
                            this.deadline = it.data.deadline;
                            this.status = it.data.status;
                            this.hit = it.data.hit;
                            this.AlertsCount = this.hit + this.deadline + this.status;
                            //this is for counter in header, count unseen alerts
                            if (document.getElementsByClassName('dueLiveTriggerHeader').length > 0) {
                                document.getElementsByClassName('dueLiveTriggerHeader')[0].innerHTML = "<u>TRIGGERS STATUS" + " " + this.status + "</u>";
                                document.querySelectorAll('[role="presentation"]')[5].innerHTML = "Alerts" + "(" + this.AlertsCount + ")";
                            }
                        });

                    }
                    if (this.reportTradingGroupId != undefined) {
                        apis.protectedApi(`${urls.apiBaseUrl}TriggerAlert/GroupCountsATG?tradingGroupId=${this.reportTradingGroupId}`).then(it => {
                            this.deadline = it.data.deadline;
                            this.status = it.data.status;
                            this.hit = it.data.hit;
                            this.AlertsCount = this.hit + this.deadline + this.status;
                            //this is for counter in header, count unseen alerts
                            if (document.getElementsByClassName('dueLiveTriggerHeader').length > 0) {
                                document.getElementsByClassName('dueLiveTriggerHeader')[0].innerHTML = "<u>TRIGGERS STATUS" + " " + this.status + "</u>";
                                document.querySelectorAll('[role="presentation"]')[6].innerHTML = "Alerts" + "(" + this.AlertsCount + ")";
                            }
                        });
                    }

                }

                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {

                    var applyEnd = args.rowData.applyUntilEnd;
                    if (applyEnd == true) {

                        datePickerObj.enabled = false;
                    }

                    args.dialog.height = "80%";
                    args.dialog.width = "50%";
                    let rows = args.form.querySelectorAll("tr");
                    for (var i = 0; i < rows.length; i = i + 2) {
                        if (rows.length > i + 1) {
                            rows[i].appendChild(
                                args.form.querySelectorAll("tr")[i + 1].cells[0]
                            );
                        }
                    }
    
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].headerText == "Apply until Default Deadline") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerActions") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerStatus") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "applyUntilEnd") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "notifyOnSystem") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "notifyEmailAddresses") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        }  else if (this.$refs.grid.getColumns()[i].field == "statusDate") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "tradeablePeriodName") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "tradeablePeriodId") {
                            this.$refs.grid.getColumns()[i].visible = false;
                            tradebalePeriodObj.value = args.rowData.tradeablePeriodId;
                        } else if (this.$refs.grid.getColumns()[i].field == "utilityTypeName") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } 
                        else if (this.$refs.grid.getColumns()[i].field == "referenceTypeId") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerStartDate") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerEndDate") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "tolerance") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerDate") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "alertType") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "alertStatus") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } 
                    }
                    if (args.requestType != 'add') {
                      //  this.contractUnits = args.rowData.unit;
                        this.units = args.rowData.unit;
                        args.form[12].value = args.form[12].value + "%";
                        args.form[10].value = args.form[10].value + " [" + this.units + "]";
                    }
                  
                    args.form[12].addEventListener("focusout", e => {
                        if (e.target.classList.contains("e-numerictextbox")) {
                            e.target.value = e.target.value + "%";
                        }
                    });

                 
                    args.form[10].addEventListener("focusout", e => {
                        if (e.target.classList.contains("e-numerictextbox")) {
                            e.target.value = e.target.value + " [" + this.units + "]";
                        }
                    });
                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            customiseCell: function (args) { // when setting up the grid this is rendering each column on its own
                if (args.column.field === 'triggerTypeName') {
                    if (args.data['triggerTypeName'] == 'Lower') {
                        args.cell.classList.add('greenBox');
                    } else {
                        args.cell.classList.add('redBox');
                    }
                } else if (args.column.field === 'triggerPrice') {
                    args.cell.textContent = args.cell.textContent + " [" + args.data['unit']  + "]";
                } else if (args.column.field === 'tolerance') {
                    args.cell.textContent = args.cell.textContent + "%";
                } else if (args.column.headerText === "Actions") {
                    if (args.data['alertStatus'] == 'Seen') {
                        args.cell.querySelector("button[title='Mark as Seen']").textContent = 'Mark as Unseen';
                        args.cell.querySelector("button[title='Mark as Seen']").title = 'Mark as Unseen';
                    }
                }
            },
            fetchUnit(id) {
                apis.protectedApi(`${urls.apiBaseUrl}Contract/AditionalTriggerData/${id}`).then(it => {
                    this.units = it.data.units;
                    this.riskManager = it.data.riskManager;
                }).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );

            }

        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn],
            chart: [ColumnSeries, StripLine, LineSeries, Category, DataLabel, DateTime, Tooltip, ChartAnnotation, Zoom, MultiColoredLineSeries]
        }
    };

</script>
<style>
/*    .e-dialog {
        max-height: 900px !important;
        top: 0px !important;
    }*/
    /*@import "../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
    .greenBox {
        background-color: #7FB7BE !important;
    }

    .redBox {
        background-color: #f78764 !important;
    }

    e-notFunctional {
        background-color: grey;
    }

    .alertExpiredTriggerHeader {
        text-transform: uppercase;
        color: #f25c54;
    }
    .greyBackground{
        background-color: lightgrey;
    }
    .alertLiveTriggerHeader {
        text-transform: uppercase;
        color: #001c55;
    }
    #alertChartContainer {
        height: 350px;
    }
    #statusAlertDialog .e-dlg-content {
        color: #4d4d4d !important;
        font-family: 'Arial', Arial, sans-serif !important;
        font-size: 14px;
    }

    #alertChartContainer_Series_0 {
        stroke: #001c55 !important;
    }

    text[id="alertChartContainer_ChartTitle"] {
        fill: #4d4d4d !important;
        font-family: 'Arial', Arial, sans-serif !important;
        font-size: 16px;
    }
    [id^="alertChartContainer_EJ-Trackball_Series_0"] {
        color: #001c55 !important;
    }

    #alertChartContainer_tooltip_Trackball_0 {
        fill: #001C55 !important;
    }
    #statusAlertGridId .e-content {
        min-height: 0px !important;
    }
    #statusAlertDialog {
        max-height: 100% !important;
        z-index: 10000 !important;
        height: 100vh !important;
        position: fixed!important;
        top: 0%!important;
    }

</style>
